import { Level, LevelAttribute, UpdateLevelInput } from "@src/redux/index";
import { Button, Col, Form, Modal, Row } from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdDelete, MdModeEdit } from "react-icons/md";
import LevelAttributesForm from "../LevelAttributesForm";

type Props = {
  levelAttributes: LevelAttribute[];
  setLevelList: any;
  levelList: Level[];
  level: Level;
};

const LevelAttributesDetails = (props: Props) => {
  const {
    levelAttributes,
    setLevelList,
    levelList,
    level,
    level: getOneLevel,
  } = props;
  const [attributeModal, setAttributeModal] = useState<boolean>(false);
  const [attributeDeleteModal, setAttributeDeleteModal] =
    useState<boolean>(false);
  const [attribute, setAttribute] = useState<LevelAttribute>();
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const handleEdit = (levelAttributes?: LevelAttribute) => {
    setAttributeModal(true);
    setAttribute(levelAttributes || {});
    form.setFieldsValue(levelAttributes);
  };

  const handleRemove = (levelAttributes?: LevelAttribute) => {
    setAttributeDeleteModal(true);
    setAttribute(levelAttributes || {});
  };

  const updateLevelAttribute = (
    parentLevelId: string,
    levelAttributeId: string,
    updatedValue: any
  ) => {
    const updateLevelList = (levels: Level[]): Level[] => {
      return levels.map((level) => {
        if (level.id === getOneLevel.id) {
          const updatedAttributes = level.levelAttributeList?.map(
            (attribute, index: number) => {
              updatedValue.sortOrder = index + 1;
              if (attribute.id === levelAttributeId) {
                return { ...attribute, ...updatedValue };
              }
              return attribute;
            }
          );

          return {
            ...level,
            levelAttributeList: updatedAttributes,
          };
        }
        return level;
      });
    };

    setLevelList((prev: Level[]) => {
      const updatedLevels = updateLevelList(prev);
      return updatedLevels;
    });
  };

  const removeLevelAttribute = () => {
    const updateLevelList = (levels: Level[]): Level[] => {
      return levels.map((level: UpdateLevelInput) => {
        if (level.id === getOneLevel.id) {
          let updatedAttributes = level.levelAttributeList?.filter(
            (attr: any) => attr.id !== attribute?.id || ""
          );
          return {
            ...level,
            levelAttributeList: updatedAttributes,
            removableLevelAttributeIdList:
              level?.removableLevelAttributeIdList?.length &&
              level?.removableLevelAttributeIdList?.length > 0
                ? [...level?.removableLevelAttributeIdList, attribute?.id]
                : [attribute?.id],
          };
        }
        return level;
      });
    };

    setLevelList((prev: Level[]) => {
      const updatedLevels = updateLevelList(prev);
      return updatedLevels;
    });
    handleCloseDeleteModal();
  };

  const handleFinish = (values: any) => {
    updateLevelAttribute(
      level?.parentLevelId || "",
      attribute?.id || "",
      values
    );
    handleClose();
  };

  const handleClose = () => {
    setAttributeModal(false);
    form.resetFields();
  };
  const handleCloseDeleteModal = () => {
    setAttributeDeleteModal(false);
  };

  return (
    <div style={{ marginTop: "20px" }}>
      {levelAttributes?.map((list: LevelAttribute, index: number) => {
        return (
          <>
            <div
              className="level-card-icon-container"
              style={{
                width: "90%",
                backgroundColor: "#4c0c29",
                padding: "10px",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
              }}
            >
              <h4>
                {index + 1}.{list.name}
              </h4>
              <div className="level-card-icon-container">
                <MdModeEdit
                  onClick={() => handleEdit(list)}
                  color="white"
                  size={18}
                  className="attribute-edit-icon"
                />
                <MdDelete
                  color="white"
                  size={18}
                  className="attribute-delete-icon"
                  onClick={() => handleRemove(list)}
                />
              </div>
            </div>

            <ul className="attribute-option-list">
              {list.optionList?.map((option: string) => {
                return <li>{option}</li>;
              })}
            </ul>
          </>
        );
      })}
      <Modal
        open={attributeModal}
        footer={null}
        title={t("update_attributes")}
        onCancel={handleClose}
      >
        <Form onFinish={handleFinish} layout="vertical" form={form}>
          <LevelAttributesForm />
          <Row justify="end" gutter={10}>
            <Col>
              <Button type="default" onClick={handleClose}>
                {t("close")}
              </Button>
            </Col>
            <Col>
              <Button htmlType="submit" type="primary">
                {t("submit")}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        open={attributeDeleteModal}
        onCancel={handleCloseDeleteModal}
        onOk={removeLevelAttribute}
        title={t("delete_attribute_confirmation")}
      >
        Are you sure you want delete a <b>{attribute?.name}</b> attribute ?
      </Modal>
    </div>
  );
};

export default LevelAttributesDetails;
